export default "__VITE_ASSET__934dc99f__"